module.exports = __webpack_public_path__ + "img/left_3.2786a791.jpg";